<template>
  <el-rate class="ts-rating" v-bind="$attrs" v-on="$listeners"></el-rate>
</template>

<script>
export default {
  name: 'TsRating'
};
</script>

<style>
</style>